import { Provider } from "react-redux";
import { ErrorBoundary } from "@myloc/myloc-utils";
import store from "./reducers/rootReducer";
import Site from "./components/Site/Site";

const App = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Site />
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
